import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import paymentIcon from "../../../assets/icons/payment-svg.svg";
import brandIcon from "../../../assets/images/Branding Section.svg";
import cbiIcon from "../../../assets/images/Central Bank of Iran Logo.svg";
import favicon from "../../../assets/images/logomain.svg";
import shaparkIcon from "../../../assets/images/Shaparak Logo.svg";
import { useGetFormDataByLink } from "../../../lib/queries/queriesAndMutations";
import { getImage } from "../../../utils/utils";
import PaymentForm from "../../forms/PaymentForm";
import InvalidPaymentFormPage from "../../shared/error-pages/InvalidPaymentFormPage";
import Loader from "../../shared/Loader";

const FormDetail = () => {
  const { id } = useParams();
  const { data: PortData, isPending, isError } = useGetFormDataByLink(id);

  const form = PortData?.form;
  const min_wage = PortData?.min_wage;
  const max_wage = PortData?.max_wage;
  const wage_percent = PortData?.wage_percent;

  useEffect(() => {
    if (form) {
      document.title = form?.name ? `فرم پرداخت | ${form.name} ` : "فرم پرداخت";
    }
  }, [form]);

  if (isPending) {
    return (
      <div className=" w-full h-screen  flex-center ">
        <Loader />
      </div>
    );
  }

  if (isError) {
    return <InvalidPaymentFormPage />;
  }

  return (
    <div className="  h-screen overflow-scroll no-scrollbar bg-primary-60 py-[150px] flex justify-center   ">
      <div className="flex flex-col items-center  max-w-[450px] md:max-w-[635px] lg:max-w-[745px]   ">
        <div className="payment-form-page-card ">
          <div className="form-header-container ">
            <div className="absolute top-0 translate-y-[-50%] left-1/2 translate-x-[-50%]   z-30 p-4  bg-primary-50 rounded-[49px]">
              <img
                src={
                  form?.image_preview
                    ? getImage(form?.image_preview)
                    : paymentIcon
                }
                alt="form-pic"
                className="object-fill w-[130px] h-[130px] rounded-[29.2px] shadow-xl border shado-xl"
              />
            </div>
          </div>

          <div className="  p-1 md:p-4 flex flex-col items-center  pt-6 min-w-[350px] ">
            <p className="text-[20px] font-semibold leading-[32px] mt-10"> {form?.name}</p>

            <PaymentForm
              type={"detail"}
              formData={
                PortData
                  ? {
                      ...form,
                      payer_name: "",
                      payer_mobile: "",
                      payer_mail: "",
                      payer_address: "",
                      payer_national_code: "",
                      payer_postal_code: "",
                      payer_description: "",
                    }
                  : {}
              }
              min_wage={min_wage}
              max_wage={max_wage}
              wage_percent={wage_percent}
            />
          </div>
        </div>

        <div className="flex flex-col items-center  gap-12 h-fit  py-4">
          <img className="h-[25px] " src={brandIcon} alt="link-icon" />
          <div className="flex gap-6">
            <img className=" " src={shaparkIcon} alt="link-icon" />
            <img className="" src={cbiIcon} alt="link-icon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormDetail;
